var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86003 9.83333V13.1667M12.5267 8.16667V13.1667M9.19336 4.83333V13.1667M5.69336 16.5H12.6934C14.0935 16.5 14.7936 16.5 15.3283 16.2275C15.7987 15.9878 16.1812 15.6054 16.4209 15.135C16.6934 14.6002 16.6934 13.9001 16.6934 12.5V5.5C16.6934 4.09987 16.6934 3.3998 16.4209 2.86502C16.1812 2.39462 15.7987 2.01217 15.3283 1.77248C14.7936 1.5 14.0935 1.5 12.6934 1.5H5.69336C4.29323 1.5 3.59316 1.5 3.05838 1.77248C2.58798 2.01217 2.20553 2.39462 1.96584 2.86502C1.69336 3.3998 1.69336 4.09987 1.69336 5.5V12.5C1.69336 13.9001 1.69336 14.6002 1.96584 15.135C2.20553 15.6054 2.58798 15.9878 3.05838 16.2275C3.59316 16.5 4.29323 16.5 5.69336 16.5Z",
    stroke: "#393B42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIconChart);
export default __webpack_public_path__ + "static/media/default-icon-chart.e3667825cce04aa25a75953a1f17c3fb.svg";
export { ForwardRef as ReactComponent };